export const productName = 'FORENSIC SCIENCE TEACHER READY';
export const productShortName = 'Forensic Science Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/ca4pc8tfTGrRQfbZxEs82X/MOCKUP_4.54.40_p._m..png';

export const checkoutUrl = 'https://forensic-science-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Forensic Science Fundamentals',
  'Volume 2 — Crime Scene Investigation & Evidence',
  'Volume 3 — Fingerprints, Impressions & Trace Evidence',
  'Volume 4 — Forensic Biology & DNA Evidence',
  'Volume 5 — Forensic Chemistry & Toxicology',
  'Volume 6 — Forensic Pathology & Anthropology',
  'Volume 7 — Digital Forensics & Cyber Evidence',
  'Volume 8 — Forensic Evidence Analysis & Case Reconstruction',
  'Volume 9 — Teaching Forensic Science',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — Forensic Science Assessment Bank',
  'Bonus 3 — 100 Case Studies & Problem-Solving Scenarios',
  'Bonus 4 — 50 Forensic Science Classroom Projects & Challenges',
  "Bonus 5 — Forensic Science Teacher's Dictionary: 200 Essential Concepts",
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex forensic science concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see forensic science's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
